module.exports = __webpack_public_path__ + "static/media/n-publicate-active.79bc6f68.svg";